import { render, staticRenderFns } from "./LeadNotificationMenu.vue?vue&type=template&id=ef5579fc&"
import script from "./LeadNotificationMenu.vue?vue&type=script&lang=js&"
export * from "./LeadNotificationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports